:host {
  display: flex;
  align-items: center;

  .user-type-switcher {
    &--hide {
      display: none;
    }
  }
}
